import { KeywordFilterValues, KeywordGetResponse, KeywordParams, KeywordValues } from '../model/keywordModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

export enum KEYWORD_TYPES {
  SET_API_KEYWORD_REQUEST_STATE = 'SET_API_KEYWORD_REQUEST_STATE',
  SET_API_KEYWORD_REQUEST_ERROR = 'SET_API_KEYWORD_REQUEST_ERROR',
  SET_API_KEYWORDS_REQUEST_STATE = 'SET_API_KEYWORDS_REQUEST_STATE',
  SET_API_KEYWORDS_REQUEST_ERROR = 'SET_API_KEYWORDS_REQUEST_ERROR',
  ADD = 'KEYWORD_ADD',
  EDIT = 'KEYWORD_EDIT',
  GET_ALL = 'KEYWORD_GET_ALL',
  GET_ALL_SUCCESS = 'KEYWORD_GET_ALL_SUCCESS',
  GET_ONE = 'KEYWORD_GET_ONE',
  GET_ONE_SUCCESS = 'KEYWORD_GET_ONE_SUCCESS',
  RESET = 'KEYWORD_RESET',
}

export interface SetApiKeywordRequestStateAction {
  type: KEYWORD_TYPES.SET_API_KEYWORD_REQUEST_STATE;
  payload: {
    apiKeywordRequestState: API_REQUEST_STATE;
  };
}

export interface SetApiKeywordRequestErrorAction {
  type: KEYWORD_TYPES.SET_API_KEYWORD_REQUEST_ERROR;
  payload: {
    apiKeywordRequestError: string;
  };
}

export interface SetApiKeywordsRequestStateAction {
  type: KEYWORD_TYPES.SET_API_KEYWORDS_REQUEST_STATE;
  payload: {
    apiKeywordsRequestState: API_REQUEST_STATE;
  };
}

export interface SetApiKeywordsRequestErrorAction {
  type: KEYWORD_TYPES.SET_API_KEYWORDS_REQUEST_ERROR;
  payload: {
    apiKeywordsRequestError: string;
  };
}

export interface ResetKeywordAction {
  type: KEYWORD_TYPES.RESET;
  payload: null;
}

export interface AddKeywordAction {
  type: KEYWORD_TYPES.ADD;
  payload: {
    keyword: KeywordValues;
  };
}

export interface EditKeywordAction {
  type: KEYWORD_TYPES.EDIT;
  payload: {
    keyword: KeywordValues;
    params: KeywordParams;
  };
}

export interface GetOneKeywordAction {
  type: KEYWORD_TYPES.GET_ONE;
  payload: {
    params: KeywordParams;
  };
}

export interface GetOneKeywordSuccessAction {
  type: KEYWORD_TYPES.GET_ONE_SUCCESS;
  payload: {
    keyword: KeywordGetResponse;
  };
}

export interface GetAllKeywordsAction {
  type: KEYWORD_TYPES.GET_ALL;
  payload: {
    keywordFilter: KeywordFilterValues;
  };
}

export interface GetAllKeywordsSuccessAction {
  type: KEYWORD_TYPES.GET_ALL_SUCCESS;
  payload: {
    keywords: KeywordGetResponse[];
  };
}

export type KeywordActions =
  | SetApiKeywordRequestStateAction
  | SetApiKeywordRequestErrorAction
  | SetApiKeywordsRequestStateAction
  | SetApiKeywordsRequestErrorAction
  | AddKeywordAction
  | ResetKeywordAction
  | EditKeywordAction
  | GetOneKeywordAction
  | GetOneKeywordSuccessAction
  | GetAllKeywordsAction
  | GetAllKeywordsSuccessAction;

export interface KeywordState {
  apiKeywordRequestState: API_REQUEST_STATE;
  apiKeywordRequestError: string | null;
  apiKeywordsRequestState: API_REQUEST_STATE;
  apiKeywordsRequestError: string | null;
  keyword: KeywordGetResponse;
  keywords: KeywordGetResponse[];
}
